define((require) => {
    "use strict";

    const _              = require("underscore");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * The model for a fade out animation.
     *
     * @class FadeOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "fadeOut"
        }, AnimationModel.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/fadeOut/FadeOutAnimationModel.js